import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom"
import { onAuthStateChanged, signOut } from "firebase/auth";
import { projectAuth } from '../firebase/config';
import Home from '../pages/hp';

const Navbar = () => {
    const [user, setUser] = useState(null);
    const [showModalOstudiu, setShowModalOstudiu] = useState(false);
    const [showModalPodminkyobjednani, setShowModalPodminkyobjednani] = useState(false);
    const [showModalKontakt, setShowModalKontakt] = useState(false);
    const [showModalTattoo, setShowModalTattoo] = useState(false);
    const [showModalPiercing, setShowModalPiercing] = useState(false);
    const [showModalMicrodermal, setShowModalMicrodermal] = useState(false);
    const [showModalGallery, setShowModalGallery] = useState(false);

    const handleShowModalOstudiu = () => setShowModalOstudiu(true);
    const handleCloseModalOstudiu = () => setShowModalOstudiu(false);

    const handleShowModalPodminkyobjednani = () => setShowModalPodminkyobjednani(true);
    const handleCloseModalPodminkyobjednani = () => setShowModalPodminkyobjednani(false);

    const handleShowModalKontakt = () => setShowModalKontakt(true);
    const handleCloseModalKontakt = () => setShowModalKontakt(false);

    const handleShowModalTattoo = () => setShowModalTattoo(true);
    const handleCloseModalTattoo = () => setShowModalTattoo(false);

    const handleShowModalPiercing = () => setShowModalPiercing(true);
    const handleCloseModalPiercing = () => setShowModalPiercing(false);

    const handleShowModalMicrodermal = () => setShowModalMicrodermal(true);
    const handleCloseModalMicrodermal = () => setShowModalMicrodermal(false);

    const handleShowModalGallery = () => setShowModalGallery(true);
    const handleCloseModalGallery = () => setShowModalGallery(false);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(projectAuth, (user) => {
            if (user) {
                setUser(user);
            } else {
                setUser(null);
            }
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []);

    const handleLogout = () => {
        signOut(projectAuth).catch((error) => {
            console.error("Error signing out: ", error);
        });
    };

    const menuToggle = (e) => {
        const burger = document.querySelector('.burger');

        if (burger.classList.contains('active')) {
            burger.classList.remove('active');
            document.querySelector('.my-dropdown-menu').classList.remove('opened');
        } else {
            burger.classList.add('active');
            document.querySelector('.my-dropdown-menu').classList.add('opened');
        }
    }



    return <>
        <button className="burger" onClick={menuToggle}>
            <i>Menu</i>
        </button>
        <div className="hero">
            {user ? (
                <h1 className="mt-5 mb-5">Tatto Kolín</h1>
            ) : (
                <img src="./logo.jpg" alt="Tattoo Kolín"/>
            )}
        </div>
        <header>
            <div className="container">
                <div className="my-dropdown-menu">
                    {user ? (
                        <nav className="navbar navbar-expand-lg bg-body-tertiary mt-5 mb-5">
                            <div className="container-fluid">
                                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                        <li className="nav-item">
                                            <NavLink to="/tattoo" className="nav-link">Tattoo</NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink to="/piercing" className="nav-link">Piercing</NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink to="/microdermal" className="nav-link">Microdermal</NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink to="/o-studiu" className="nav-link">O studiu</NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink to="/galerie" className="nav-link">Galerie</NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink to="/podminky-objednani" className="nav-link">Podmínky objednání</NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink to="/kontakt" className="nav-link">Kontakt</NavLink>
                                        </li>
                                    </ul>
                                    <NavLink to="/" onClick={handleLogout} className="btn btn-primary">Odhlásit</NavLink>
                                </div>
                            </div>
                        </nav>
                    ) : (
                        <div>
                            <nav className={user && ("d-none")}>
                                <ul className="extra-menu">
                                    <li id="tattoo" onClick={handleShowModalTattoo}>
                                        Tattoo
                                    </li>
                                    <li id="piercing" onClick={handleShowModalPiercing}>
                                        Piercing
                                    </li>
                                    <li id="microdermal" onClick={handleShowModalMicrodermal}>
                                        Microdermal
                                    </li>
                                </ul>
                            </nav>
                            <ul className="nav">
                                <li id="ostudiu" onClick={handleShowModalOstudiu}>
                                    O studiu
                                </li>
                                <li id="galerie" onClick={handleShowModalGallery}>
                                    Galerie
                                </li>
                                <li id="podminky-objednani" onClick={handleShowModalPodminkyobjednani}>
                                    Podmínky objednání
                                </li>
                                <li id="kontakt" onClick={handleShowModalKontakt}>
                                    Kontakt
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </header>

        <Home
            showModalOstudiu={showModalOstudiu}
            handleCloseModalOstudiu={handleCloseModalOstudiu}
            showModalPodminkyobjednani={showModalPodminkyobjednani}
            handleCloseModalPodminkyobjednani={handleCloseModalPodminkyobjednani}
            showModalKontakt={showModalKontakt}
            handleCloseModalKontakt={handleCloseModalKontakt}
            showModalTattoo={showModalTattoo}
            handleCloseModalTattoo={handleCloseModalTattoo}
            showModalPiercing={showModalPiercing}
            handleCloseModalPiercing={handleCloseModalPiercing}
            showModalMicrodermal={showModalMicrodermal}
            handleCloseModalMicrodermal={handleCloseModalMicrodermal}
            showModalGallery={showModalGallery}
            handleCloseModalGallery={handleCloseModalGallery}
        />
    </>

}

export default Navbar;

